import { V0_1IncrementalResultsMerger33xbt4nwq2a5 as V0_1IncrementalResultsMerger } from './V0_1IncrementalResultsMerger.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { V0_2IncrementalResultsMerger1xexi65gw211w as V0_2IncrementalResultsMerger } from './V0_2IncrementalResultsMerger.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var V0_1Class;
function V0_1() {
  if (V0_1Class === VOID) {
    class $ {
      constructor() {
        this.acceptHeader_1 = 'multipart/mixed;deferSpec=20220824, application/graphql-response+json, application/json';
      }
      get_acceptHeader_vmdvr2_k$() {
        return this.acceptHeader_1;
      }
      newIncrementalResultsMerger_frcl62_k$() {
        return new (V0_1IncrementalResultsMerger())();
      }
    }
    initMetadataForObject($, 'V0_1');
    V0_1Class = $;
  }
  return V0_1Class;
}
var V0_1_instance;
function V0_1_getInstance() {
  return V0_1_instance;
}
var V0_2Class;
function V0_2() {
  if (V0_2Class === VOID) {
    class $ {
      constructor() {
        this.acceptHeader_1 = 'multipart/mixed;incrementalSpec=v0.2, application/graphql-response+json, application/json';
      }
      get_acceptHeader_vmdvr2_k$() {
        return this.acceptHeader_1;
      }
      newIncrementalResultsMerger_frcl62_k$() {
        return new (V0_2IncrementalResultsMerger())();
      }
    }
    initMetadataForObject($, 'V0_2');
    V0_2Class = $;
  }
  return V0_2Class;
}
var V0_2_instance;
function V0_2_getInstance() {
  return V0_2_instance;
}
function get_impl(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.ordinal_1) {
    case 0:
      tmp = V0_1_instance;
      break;
    case 1:
      tmp = V0_2_instance;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
//region block: init
V0_1_instance = new (V0_1())();
V0_2_instance = new (V0_2())();
//endregion
//region block: exports
export {
  get_impl as get_impl1focltg7f8wvg,
};
//endregion

//# sourceMappingURL=IncrementalDeliveryProtocolImpl.mjs.map
